import { render } from "./ReviewPageItem.vue?vue&type=template&id=7ccf20fd&scoped=true"
import script from "./ReviewPageItem.vue?vue&type=script&lang=js"
export * from "./ReviewPageItem.vue?vue&type=script&lang=js"

import "./ReviewPageItem.vue?vue&type=style&index=0&id=7ccf20fd&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccf20fd"]])

export default __exports__